import { all, call, put, select } from 'redux-saga/effects';
import * as Api from '../api';
import { actions, StoreState } from '../store/utils';
import { invokeApiRetry, takeEvery } from '../utils/apiActions';
import { ApiResult } from './api';

const onFetchCalendars = takeEvery(actions.fetchCalendarsRequest, function* (state, { start, end, email }) {
   yield invokeApiRetry(function* () {
      const data: ApiResult<typeof Api.fetchCalendars> = yield call(Api.fetchCalendars, start, end, email)
      const checkinResource: StoreState['checkinResource'] | undefined = yield select((s: StoreState) => s.checkinResource)
      if (checkinResource) {
         let arr = data[start];
         // filter out elements of arr that has meetingRooms[0].emailAddress not matching checkinResource
         if (data && Array.isArray(arr) && arr.length > 0) {
            arr = arr.filter(
               e =>
                  e.meetingRooms.length > 0 &&
                  e.meetingRooms[0].emailAddress?.toLowerCase() === checkinResource.toLowerCase()
            );
            data[start] = arr;
         }
      }
      yield put(actions.fetchCalendarsResponse(email, data))
   })
})

export default all([
   onFetchCalendars,
])
